import React from "react";
import Panel from "../../common/components/panel";
import { ReprocessDataPlanDetailsFragment } from "../../graphql/generated";
import ReprocessDataTaskTable from "../../reprocess-data-task/components/table";

const ReprocessDataPlanTasks: React.FC<{
  plan?: ReprocessDataPlanDetailsFragment;
}> = ({ plan }) => {
  return (
    <Panel>
      <Panel.Title>Tasks</Panel.Title>
      <Panel.Body>
        <div className="grid grid-cols-1">
          <ReprocessDataTaskTable tasks={plan?.tasks} />
        </div>
      </Panel.Body>
    </Panel>
  );
};

export default ReprocessDataPlanTasks;
